module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-48.5c4530fd.svg";